import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
	GradeConnectQueueItem,
	getPersonGradeConnectQueue,
} from "../../api/person/grade-connect-queue";
import { formatDateTime } from "../../utils/date-formatting";
import { useGlobalState } from "../globalState";

interface PersonGradeConnectQueueProps {
	personId: number;
}

export const PersonGradeConnectQueue = ({ personId }: PersonGradeConnectQueueProps) => {
	const [items, setItems] = useState<GradeConnectQueueItem[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const { currentUser } = useGlobalState();

	useEffect(() => {
		if (!currentUser.is_superuser || !personId) {
			setLoading(false);
			return;
		}

		getPersonGradeConnectQueue(personId)
			.then((res) => setItems(res.results))
			.finally(() => setLoading(false));
	}, [personId, currentUser.is_superuser]);

	if (!currentUser.is_superuser || loading) {
		return null;
	}

	return (
		<Accordion
			defaultExpanded={false}
			data-component="grade-connect-queue-accordion"
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				data-component="accordion-summary"
			>
				<Typography variant="h6">GradeConnectQueue ({items.length})</Typography>
			</AccordionSummary>
			<AccordionDetails data-component="accordion-details">
				<TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
					<Table size="small" sx={{ minWidth: 600 }}>
						<TableHead>
							<TableRow>
								<TableCell>ID</TableCell>
								<TableCell>Created</TableCell>
								<TableCell>Assignment</TableCell>
								<TableCell>Mode</TableCell>
								<TableCell>Type</TableCell>
								<TableCell>Priority</TableCell>
								<TableCell>Viewed</TableCell>
								<TableCell>Dequeued</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{items.map((item) => (
								<TableRow key={item.id} data-component="queue-row">
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.id}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{formatDateTime(item.created)}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.assignment}
										</Typography>
									</TableCell>
									<TableCell>
										<Chip label={item.mode_label} size="small" />
									</TableCell>
									<TableCell>
										{item.band_label ? (
											<Chip
												label={item.band_label}
												size="small"
											/>
										) : (
											"—"
										)}
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.priority}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.viewed
												? formatDateTime(item.viewed)
												: "—"}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.dequeued
												? formatDateTime(item.dequeued)
												: "—"}
										</Typography>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</AccordionDetails>
		</Accordion>
	);
};
